var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 15.9167H5.83333C3.82397 15.9167 2.61253 15.5102 1.8845 14.7822C1.15647 14.0541 0.75 12.8427 0.75 10.8333V5.83333C0.75 3.82397 1.15647 2.61253 1.8845 1.8845C2.61253 1.15647 3.82397 0.75 5.83333 0.75H10.8333C12.8427 0.75 14.0541 1.15647 14.7822 1.8845C15.5102 2.61253 15.9167 3.82397 15.9167 5.83333V10.8333C15.9167 12.8427 15.5102 14.0541 14.7822 14.7822C14.0541 15.5102 12.8427 15.9167 10.8333 15.9167Z",
    stroke: "#B7C0CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.8ac42573b43eecebb3f116af0b4c011c.svg";
export { ForwardRef as ReactComponent };